import { setLocale, useIntl } from '@umijs/max';
import { AvatarDropdown as CoreAvatarDropdown, useLocale } from '@zhiyue/core';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';

const AvatarDropdown: React.FC = () => {
  const intl = useIntl();
  const { setLocale: setSessionLocale } = useLocale();
  return (
    <CoreAvatarDropdown
      mergeDefaultItems
      items={[
        {
          key: 'help',
          label: intl.formatMessage({ id: 'menu.crm.help' }),
          href: 'https://docs.shanhuyun.cn/',
          target: '_blank',
        },
        ...[
          { key: 'zh-CN', label: '简体中文' },
          { key: 'zh-TW', label: '繁體中文' },
          { key: 'en-US', label: 'English' },
          { key: 'ja-JP', label: '日本語' },
        ].map((item) => ({ ...item, key: `locale:${item.key}` })),
      ]}
      onAction={(key) => {
        if (key.startsWith('locale:')) {
          const locale = key.slice(7);
          setSessionLocale(locale);
          setLocale(locale, false);
        }
      }}
      appId={BizAppConfig.appSsoClientId}
      personalCenterUrl={BizAppConfig.appPersonalCenterUrl}
      tenantManagementUrl={BizAppConfig.appTenantManagementUrl}
      workbenchUrl={BizAppConfig.appWorkbenchUrl}
    />
  );
};

export default AvatarDropdown;
